import { httpClient } from 'common/services';
import type { AstSignMailSwitchboardTransferRequest } from 'features/ast-signmail/interfaces';

async function transferToAst({
  sessionId,
  hearingParticipantId,
  callobject,
}: AstSignMailSwitchboardTransferRequest) {
  const route = `/voice-sessions/${sessionId}/participants/${hearingParticipantId}/ast-transfer`;
  const response = await httpClient.put<void>(route, { callobject });
  return response.data;
}

export const AstSignMailDaoService = {
  transferToAst,
};
